/**
 * Loader/index.js
 * desc: loader element for page and inline content
 * note: stateless presentational component
 */
'use strict';

import './styles.css';


const Loader = () => (
    <ul className="loader">
        <li></li>
        <li></li>
        <li></li>
    </ul>
);


export default Loader;
